import { useCustomerData } from '@cinch-labs/customer-data-segment'
import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'

import styles from './sale-promo-banner.module.css'

export function SalePromoBanner() {
  const { trackEvent } = useCustomerData()
  const handleOnClick = () => {
    const data = {
      event: {
        name: 'click',
        category: 'link',
        action: 'navigate',
        label: 'shop sale now',
      },
    }
    trackEvent({
      type: 'track',
      eventName: 'Promotion Clicked',
      data: {
        name: 'Sale promo banner - cars on offer',
        position: 'top banner',
      },
    })
    sendDigitalDataEvent(data)
  }
  return (
    <>
      <span className={styles.saveTag}>SHOP</span>
      <p className={styles.text}>
        Price reductions on{' '}
        <a href="/used-cars?tags=cars-on-offer" onClick={handleOnClick}>
          selected cars
        </a>
        , from £250 - £1000 off
      </p>
    </>
  )
}

export default SalePromoBanner
